var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4.002 4.002 0 0 1 3-3.874V4a1 1 0 1 1 2 0v9.126A4.002 4.002 0 0 1 8 21a4 4 0 0 1-4-4Zm11 3a1 1 0 1 0 2 0v-9.126A4.002 4.002 0 0 0 16 3a4 4 0 0 0-1 7.874V20ZM14 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
    fill: "#1C3F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.99207d523109ba74e5691de7af8117ad.svg";
export { ForwardRef as ReactComponent };